import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "me-3" }, "Cheater IP", -1)
const _hoisted_5 = { class: "card-toolbar" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "table align-middle table-row-dashed fs-6 gy-5" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", null, "Id", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("th", null, "IP", -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }

import { ref, onMounted, inject } from "vue";
import CheaterIpCreate from "../components/CheaterIpCreate.vue";
import { InfoFilled } from "@element-plus/icons-vue";
import ToolServices from "../services/ToolServices";
import { ElNotification } from "element-plus";
import TableFooter from "@/components/TableFooter.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CheaterIp',
  setup(__props) {

const isLoading = inject<any>("isLoading");
const detail = ref(Array<any>());
const criteria = ref({
  page: 1,
  size: 25,
  ip: "",
});
const createModalRef = ref(null);

const showCreate = (item?: any) => {
  createModalRef.value?.show(item);
};

const reset = () => {
  criteria.value = { page: 1, size: 25, ip: "" };
  fetchData(1);
};

const fetchData = async (_page: number) => {
  isLoading.value = true;
  criteria.value.page = _page;
  try {
    const data = await ToolServices.getCheaterIpList(criteria.value);
    criteria.value = data.criteria;
    detail.value = data.data;
  } catch (error) {
    console.log(error);
  }
  isLoading.value = false;
};

const activeToggle = async (item: any) => {
  try {
    await ToolServices.updateCheaterIp(item.id, item);
    ElNotification.success({
      title: "Status Update Success - " + item.ip,
      offset: 100,
    });
  } catch (error) {
    console.log(error);
  }
};

const deleteCheaterIp = async (id: number) => {
  try {
    await ToolServices.deleteCheaterIp(id);
    ElNotification.success({
      title: "Success",
      message: "Ip Deleted",
      offset: 100,
    });
    fetchData(1);
  } catch (error) {
    console.log(error);
    ElNotification.error({
      title: "Error",
      message: error.message,
      offset: 100,
    });
  }
};

const onEventSubmitted = () => {
  fetchData(1);
};

onMounted(() => {
  fetchData(1);
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_el_input, {
          class: "w-200px me-3",
          modelValue: criteria.value.ip,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria.value.ip) = $event)),
          disabled: _unref(isLoading)
        }, null, 8, ["modelValue", "disabled"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (fetchData(1))),
          plain: "",
          disabled: _unref(isLoading)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.search")), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          onClick: reset,
          plain: "",
          disabled: _unref(isLoading)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.clear")), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (showCreate()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.addCheaterIp")), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("table", _hoisted_7, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.status")), 1),
            _hoisted_8,
            _hoisted_9,
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.note")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.operator")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("action.action")), 1)
          ])
        ]),
        (_unref(isLoading))
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
              _createVNode(_component_LoadingRing)
            ]))
          : (!_unref(isLoading) && detail.value?.length === 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_11, [
                _createVNode(_component_NoDataBox)
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, [
                      _createVNode(_component_el_switch, {
                        "active-color": "#13ce66",
                        "inactive-color": "#ff4949",
                        modelValue: item.enabled,
                        "onUpdate:modelValue": ($event: any) => ((item.enabled) = $event),
                        onChange: ($event: any) => (activeToggle(item))
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(item.id), 1),
                    _createElementVNode("td", null, _toDisplayString(item.ip), 1),
                    _createElementVNode("td", null, _toDisplayString(item.note), 1),
                    _createElementVNode("td", null, _toDisplayString(item.operatorName), 1),
                    _createElementVNode("td", null, [
                      _createVNode(_component_TimeShow, {
                        "date-iso-string": item.createdOn
                      }, null, 8, ["date-iso-string"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: ($event: any) => (showCreate(item))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("action.edit")), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_component_el_popconfirm, {
                        "confirm-button-text": "Yes",
                        "cancel-button-text": "No",
                        icon: _unref(InfoFilled),
                        "icon-color": "#626AEF",
                        title: "Delete Cheater IP",
                        onConfirm: ($event: any) => (deleteCheaterIp(item.id)),
                        width: "300px"
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_button, { type: "danger" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("action.delete")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["icon", "onConfirm"])
                    ])
                  ]))
                }), 128))
              ]))
      ]),
      _createVNode(TableFooter, {
        onPageChange: fetchData,
        criteria: criteria.value
      }, null, 8, ["criteria"])
    ]),
    _createVNode(CheaterIpCreate, {
      ref_key: "createModalRef",
      ref: createModalRef,
      onEventSubmit: onEventSubmitted
    }, null, 512)
  ]))
}
}

})